import localStyles from "../components/Bonus3Section/styles.module.scss";

export const slugify = function (str: string) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = ucFirst(str); // convert string to lowercase
    str = str.replace(/[^a-zA-Z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, ''); // remove consecutive hyphens
    return str;
}

export const slugifyWithDash = function (str: string) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = ucFirst(str); // convert string to lowercase
    str = str.replace(/&/g, 'and');
    str = str.replace(/[^a-zA-Z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    return str;
}

export const ucFirst = function (word: string) {
    return word.charAt(0).toUpperCase()
        + word.slice(1);
}

export const getCurrency = function (currencyCode: string) {
    return currencyCode === 'USD' ? '$' : currencyCode;
}

export const getFormattedSeatValue = function (label, price, comparePrice, customCompatibility) {
    let subtitle = '';
    let value = label;
    let diff: string = '';
    if (comparePrice) {
        diff = '' + formatMoney(comparePrice.replace('$', '') - price.replace('$', ''));
    }
    switch (label) {
        case 'First Row':
            value = 'First Row';
            subtitle = '2 Front Seats';
            if (customCompatibility === 'Y' || customCompatibility === 'F' || customCompatibility === 'YF') {
                value = 'Front Seats';
            }
            break;
        case 'Back Row':
            value = 'Back Row';
            subtitle = '1 Back Bench';
            if (customCompatibility === 'Y' || customCompatibility === 'YF') {
                value = 'Back Bench';
            }
            break;
        case 'Middle Row':
            value = 'Middle Row';
            subtitle = '2 Seats';
            break;
        case 'Front Seats':
            value = 'Front Seats';
            subtitle = '2 Front Seats';
            break;
        case 'Universal Back Bench':
            value = 'Back Bench';
            subtitle = '1 Universal Rear';
            break;
        case 'First Row & Back Row':
            value = 'Bundle';
            subtitle = '2 Fronts & 1 Back';
            break;
        case 'Second or Third Row':
            if (customCompatibility === 'Y' || customCompatibility === 'YJ') {
                value = 'Second Row';
                subtitle = 'Rear Seats';
            }
            break;
        case '2 Row Bundle':
            if (customCompatibility === 'Y' || customCompatibility === 'YJ') {
                value = 'Bundle';
                subtitle = '';
            }
            break;
        case 'Bundle':
            value = `Bundle & Save`; //${diff ? '$' + diff : ''}
            if (customCompatibility === 'N') {
                subtitle = '2 Fronts & 1 Back';
            }
            if (customCompatibility === 'Y' || customCompatibility === 'F'
                || customCompatibility === 'YF' || customCompatibility === 'YJ'
                || customCompatibility === 'FJ' || customCompatibility === 'TJ') {
                subtitle = '2 Fronts & 1 Back';
            }
            if (customCompatibility === 'T') {
                subtitle = 'All Rows';
            }
            break;
    }

    return {value, subtitle, diff};
}

export const formatSelectedSeat = function (selectedSeat: string | undefined, product: any, compatibility_custom: string) {
    let price = '';
    let comparePrice = '';
    const parsed_seat = parseSeatValue(selectedSeat, compatibility_custom);
    const priceEl = product.variants.edges.filter(v => v.node.selectedOptions
        .filter(er => er.name === 'Seats' && er.value === parsed_seat).length > 0);
    // console.log('priceEl:', priceEl);
    if (priceEl.length > 0) {
        const currency = getCurrency(priceEl[0].node.priceV2.currencyCode);
        price = currency + formatMoney(parseFloat(priceEl[0].node.priceV2.amount));

        if (priceEl[0].node.compareAtPrice) {
            comparePrice = currency + formatMoney(parseFloat(priceEl[0].node.compareAtPrice.amount));
        }

        const {value, subtitle, diff} = getFormattedSeatValue(parsed_seat, price, comparePrice, compatibility_custom);
        return `${parsed_seat} (${subtitle} - ${price})`;
    }

    return '';
}

export const getImageUrl = function (src, maxWidth, maxHeight) {

    let size = maxWidth + 'x';
    if (maxHeight) {
        size += maxHeight;
    }
    let newSrc = src.replace('.jpg', '_' + size +'.jpg');
    newSrc = newSrc.replace('.png', '_' + size + '.png');
    newSrc = newSrc.replace('.webp', '_' + size + '.webp');
    if (newSrc.indexOf('?') > -1) {
        newSrc = newSrc.replace('?', '?crop=center&format=pjpg&');
    } else {
        newSrc = newSrc + '?crop=center&format=pjpg&';
    }

    return newSrc;
}

export const parseSeatValue = function (seatValue, compatibility_custom) {
    // console.log('compatibility_custom', compatibility_custom);
    let seat = seatValue || '';
    switch (seat) {
        case 'First Row,Back Row':
            seat = 'First Row & Back Row';
            break;
        case 'Back Row,First Row':
            seat = 'First Row & Back Row';
            break;
        case 'Middle Row,Back Row':
            seat = 'Middle Row & Back Row';
            break;
        case 'Back Row,Middle Row':
            seat = 'Middle Row & Back Row';
            break;
        case 'First Row,Middle Row':
            seat = 'First Row & Middle Row';
            break;
        case 'Middle Row,First Row':
            seat = 'First Row & Middle Row';
            break;

        default:
            break;
    }
    return seat;
}

export const parsedSeatUserFriendly = function(seatValue, compatibility_custom) {
    let seat = seatValue || '';
    // console.log('parsedSeatUserFriendly', seatValue, compatibility_custom);
    if (compatibility_custom === 'YF' || compatibility_custom === 'Y') {
        seat = seat.replace('First Row & Back Row', 'Bundle');
    }
    if (compatibility_custom === 'F' || compatibility_custom === 'Y' || compatibility_custom === 'YF') {
        seat = seat.replace('First Row', 'Front Seats');
    }
    if (compatibility_custom === 'Y' || compatibility_custom === 'YF') {
        seat = seat.replace('Back Row', 'Back Bench');
    }
    //console.log('parsedSeatUserFriendly result', seat);
    return seat;
}

export const isCustom = function (currentAppData) {
    return currentAppData.check && (currentAppData.check.compatibility === 'N'
        && currentAppData.check.compatibility_custom !== 'N');
}

export const isCustomThreeRows = function (currentAppData) {
    return false;
    // return currentAppData.check && (currentAppData.check.compatibility === 'N'
    //     && currentAppData.check.compatibility_custom === 'T');
}

export const isCustomFront = function (currentAppData) {
    return currentAppData.check && (
        (currentAppData.check.compatibility_custom === 'F'
            || currentAppData.check.compatibility_custom === 'FJ'));
}

export const isCustomFrontJump = function (currentAppData) {
    return currentAppData.check && (
        window.scs_force_normal !== true &&
        (currentAppData.check.compatibility_custom === 'YF'
            || currentAppData.check.compatibility_custom === 'FJ')
    );
}

export const isCustomJump = function (currentAppData) {
    return currentAppData.check && (currentAppData.check.compatibility === 'N'
        &&
        (currentAppData.check.compatibility_custom === 'YJ'
            || currentAppData.check.compatibility_custom === 'FJ'
            || currentAppData.check.compatibility_custom === 'TJ'
            || currentAppData.check.compatibility_custom === 'YF'
        )
    );
}

export const formatMoney = function (money) {
    return window.scs_force_custom ? money.toFixed(2) : money.toFixed(0);
}

export const isRear = function(currentAppData) {
    return window.scs_show_bonus_section && currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1 || currentAppData?.seat?.indexOf('Back') !== -1 || currentAppData?.seat?.indexOf('Front') !== -1);
}

export const isFront = function(currentAppData) {
    return window.scs_show_bonus_section && currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1 || currentAppData?.seat?.indexOf('Front') !== -1);
}

export const isBundle = function(currentAppData) {
    return window.scs_show_bonus_section && currentAppData?.seat && (currentAppData?.seat?.indexOf('Bundle') !== -1);
}

export const getOfferPrice = function(price: number) {
    if (window.scs_show_earlybf_section) {
        return price - 20;
    }
    return price;
}

export const  getCompareOfferPrice = function(price: number, compare_price: number) {
    if (window.scs_show_earlybf_section) {
        console.debug('compare_price: ', compare_price, 'price: ', price);
        if (compare_price !== undefined) {
            return compare_price;
        }
        return price;
    }
    return compare_price;
}